import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NzModalService, NzModalSubject} from "ng-zorro-antd";
import {GlobalService} from "../../services/global.service";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {CookieService} from "ngx-cookie-service";

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.css']
})
export class CaptchaComponent implements OnInit {
  formModel: FormGroup;
  // 验证码
  captcha: string;

  // 请求头
  private headers: HttpHeaders;

  //本地
  private baseUrl = 'xhsCreditApi/v1';  // 没注入httpService，因为会引起循环引用

  constructor(fb: FormBuilder, private subject:NzModalSubject,private showAlert: NzModalService,
              private globalService: GlobalService, private cookieService: CookieService,private http: HttpClient) {
    // 请求头配置
    this.headers = new HttpHeaders()
      .set('Content-Type', 'application/json;charset=UTF-8');

    this.formModel = fb.group({
      captcha: ['', [Validators.required]],
    });

    this.captcha = this.generateCaptcha();
  }

  public getBaseUrl(): any{
    return this.baseUrl;
  }

  /**
   * post请求
   * @param {string} url
   * @param body
   * @returns {any}
   */
  post(url: string, body): any {
    this.setHeaders();
    body = JSON.stringify(body);
    return this.http.post(this.getBaseUrl() + url, body, {headers: this.headers});
  }

  /**
   * 将对象类型的参数转换成HttpParams类型
   * @param params
   * @returns {HttpParams}
   */
  encodeParams(params: any): HttpParams {
    let str = '';
    Object.keys(params).forEach(key => {
      str += key + '=' + params[key] + '&';
    });
    return new HttpParams({fromString: str.substring(0, str.length - 1)});
  }

  /**
   * 将cookie中的token设置在header请求头里，token每1小时变更一次，所以需要每次请求都去cookie中取一下
   */
  setHeaders() {
    let userType = this.globalService.getUserInfo("_userType");
    this.headers = this.headers.set("User-Type", userType ? userType : 'tourist').
    set("Set-Cookie", "auth-token="+this.cookieService.get("auth-token"));
  }

  // 更换验证码
  changeCap(type?: any) {
    $("nz-input[formcontrolname='captcha'] input").val("");
    $(".captcha").attr("src", this.generateCaptcha(type) + "&"+ Math.random());
  }

  generateCaptcha(type?: any) {
    let preUrl = "/auth/captcha.jpg";
    if (this.globalService.getValue("JessionID")) {
      return this.getBaseUrl() + preUrl + "?JessionID=" + this.globalService.getValue("JessionID");
    } else {
      let uuid = this.globalService.uuid();
      this.globalService.setKey("JessionID", uuid);
      return this.getBaseUrl() + preUrl + "?JessionID=" + uuid;
    }
  }

  ngOnInit() {
  }

  validate(){
      // console.log(this.prevUrl + "?" + this.prevParams);
      let validate = true;
      let userName = true;

      if (!this.formModel.get("captcha").valid) {
        this.formModel.get("captcha").markAsDirty();
        return;
      }
      validate = this.formModel.get("captcha").valid;
      if (validate) {//验证通过时

        this.post("/auth/validateCaptcha2", {
          captcha: this.formModel.get("captcha").value,
          jessionID:this.globalService.getValue("JessionID")
        }).subscribe(result => {
          // console.log(result)
          var responseSuc = false;
          if (result.stateCode == '20116') {
            this.subject.destroy('onCancel');
            window.location.reload();
          } else if (result.stateCode == '20115') {
            //this.showMsg.error("手机号码为空");
            this.showAlert.error({content: '验证码错误，请重新输入！', width: '300px', okText: '确认'});
          } else {
            // this.showMsg.error("其他未知错误");
            this.showAlert.error({content: '系统错误，请稍后再试！', width: '300px', okText: '确认'});
          }

          if (!responseSuc) {
            this.changeCap();
            return;
          }
        });

      }
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/captcha/captcha.component.ts